export const CALENDAR_OPTIONS = ['Apple', 'Google', 'iCal', 'Microsoft365', 'MicrosoftTeams', 'Outlook.com'];

export const YES_NO = [
     { id: 'yes', name: 'Yes', status: true },
     { id: 'no', name: 'No', status: false },
];

export const YES_NO_OPTIONS = [
     { value: 'yes', label: 'Yes', status: true },
     { value: 'no', label: 'No', status: false },
];

export const YES_NO_RADIOS = [
     { label: 'Yes', value: true },
     { label: 'No', value: false },
];

export const STATUS_OPTIONS = [
     { id: 'enable', name: 'Enable', status: true },
     { id: 'disabled', name: 'Disabled', status: false },
];

export const COURSE_STATUS_OPTIONS = [
     { id: 'not-started', name: 'Not Started' },
     // { id: 'no-access', name: 'No Access' },
     { id: 'accessed', name: 'Accessed' },
     { id: 'in-progress', name: 'In Progress' },
     { id: 'completed', name: 'Completed' },
];

export const COURSE_STATUS_MULTI_OPTIONS = [
     { label: 'Not Started', value: 'not-started' },
     { label: 'Accessed', value: 'accessed' },
     { label: 'In Progress', value: 'in-progress' },
     { label: 'Completed', value: 'completed' },
];

export const LINK_STATUS_OPTIONS = [
     { id: 'AVAILABLE', name: 'Available' },
     { id: 'ASSIGNED', name: 'Assigned' },
];

export const PRODUCT_CREDIT_STATUS_OPTIONS = [
     { id: 'UNASSIGNED', name: 'Unassigned' },
     { id: 'RESERVED', name: 'Reserved' },
     { id: 'NO_SELECTED', name: 'No Selected' },
     { id: 'SELECTED', name: 'Selected' },
];

export const PRODUCT_BUNDLE_STATUS_OPTIONS = [
     { id: 'open', name: 'OPEN' },
     { id: 'reserved', name: 'RESERVED' },
     { id: 'accepted', name: 'ACCEPTED' },
];

export const COUPON_TYPES = [
     { id: 'DISCOUNT_AMOUNT_IN_TOTAL', name: 'Discount On Product' },
     { id: 'DISCOUNT_AMOUNT_IN_CART', name: 'Discount On Cart' },
];

export const DISCOUNT_TYPES = [
     { id: 'price', name: 'Price' },
     { id: 'percent', name: 'Percent' },
];

export const PRODUCT_MODES = [
     { id: 'BASIC', name: 'Basic' },
     { id: 'ADVANCE', name: 'Advance' },
];

export const PRODUCT_MEDIA_TYPES = [
     { id: 'document', name: 'Document' },
     { id: 'digital-document', name: 'Digital Document' },
];

export const ATTACHMENT_TYPES = [
     { id: 'DOCUMENT ', name: 'Document' },
     { id: 'IMAGE ', name: 'Image' },
     { id: 'VIDEO  ', name: 'Video' },
];

export const INDUSTRY_DATA = [
     { id: 'Active Military', name: 'Active Military' },
     { id: 'Clinics', name: 'Clinics' },
     { id: 'College & University', name: 'College & University' },
     { id: 'Correctional Institution', name: 'Correctional Institution' },
     { id: 'Health Systems', name: 'Health Systems' },
     { id: 'K-12 Education', name: 'K-12 Education' },
     { id: 'Native American Services', name: 'Native American Services' },
     { id: 'Private Practice', name: 'Private Practice' },
     { id: 'Veterans Association', name: 'Veterans Association' },
];

export const CATEGORY_LEVEL_1 = [
     { id: 'Learn & Demonstrate Your Knowledge', name: 'Learn & Demonstrate Your Knowledge', order: 1 },
     { id: 'Gain Hands-on Experience in CAMS', name: 'Gain Hands-on Experience in CAMS', order: 2 },
     { id: 'Professional Information', name: 'Professional Information', order: 3 },
     { id: 'Reaffirm & Deepen Your Knowledge in CAMS', name: 'Reaffirm & Deepen Your Knowledge in CAMS', order: 4 },
     { id: 'Broaden Your CAMS Training', name: 'Broaden Your CAMS Training', order: 5 },
     { id: 'Stay Up to Date', name: 'Stay Up to Date', order: 6 },
];

export const CATEGORY_LEVEL_2 = [
     { id: 'TEENS', name: 'TEENS', order: 1 },
     { id: 'DIFFICULT CASES', name: 'DIFFICULT CASES', order: 2 },
     { id: 'MALPRACTICE', name: 'MALPRACTICE', order: 3 },
];

export const DISCIPLINE_DATA = [
     { id: 'LMFT', name: 'LMFT' },
     { id: 'Counselor', name: 'Counselor' },
     { id: 'Substance Abuse Counselor', name: 'Substance Abuse Counselor' },
     { id: 'Medical Professional', name: 'Medical Professional' },
     { id: 'Social Worker', name: 'Social Worker' },
     { id: 'Psychologist', name: 'Psychologist' },
     { id: 'Professional Counselor', name: 'Professional Counselor' },
     { id: 'Other', name: 'Other' },
];

export const TEST_ACCESS_SETTING_DATA = [
     { id: 'not-require', name: 'Not Require' },
     { id: 'test-first', name: 'Test First' },
     { id: 'survey-first', name: 'Survey First' },
];

export const PURCHASE_TYPE_DATA = [
     { id: 'organization', name: 'Organization' },
     { id: 'individual', name: 'Individual' },
     { id: 'invisible', name: 'Invisible' },
     { id: 'both', name: 'Both' },
];

export const DISCOUNT_TYPE_DATA = [
     { id: 'price', name: 'Price' },
     { id: 'percent', name: 'Percent' },
];

export const QUESTION_TYPE_DATA = [
     {
          id: 'single-choice',
          name: 'Single Choice',
     },
     {
          id: 'multiple-choice',
          name: 'Multiple Choice',
     },
     {
          id: 'ask-for-answer',
          name: 'Ask For Answer',
     },
     {
          id: 'dropdown-list-choice',
          name: 'Drop-down List Choice',
     },
     {
          id: 'likert-scale',
          name: 'Likert Scale',
     },
];

export const QUESTION_DIRECTION_TYPE_DATA = [
     {
          id: 'vertical',
          name: 'Vertical',
     },
     {
          id: 'horizontal',
          name: 'Horizontal',
     },
];

export const ANSWER_DROPDOWN_LIST_TYPE_DATA = [
     {
          id: 'country',
          name: 'Country',
     },
     {
          id: 'state',
          name: 'State',
     },
];

export const TRAINING_TYPE_DATA = [
     { id: 'role-play', name: 'Role Play' },
     { id: 'call', name: 'Call' },
];

export const LOCATION_TYPE_DATA = [
     { id: 'online', name: 'Online' },
     { id: 'in-person', name: 'In-Person' },
];

export const EMAIL_PREFERENCES = [
     { id: 'receiving', name: 'Receiving' },
     { id: 'not-receiving', name: 'Not Receiving' },
];

export const RELEASE_STATUSES = [
     { id: 'manually', name: 'Manually' },
     { id: 'with-invoice', name: 'With Invoice' },
];

export const ORDER_INVOICE_STATUSES = [
     { id: 'draft', name: 'Draft' },
     { id: 'paid', name: 'Paid' },
     { id: 'unpaid', name: 'Unpaid' },
];

export const PRIVATE_YES_NO = [
     { id: 'true', name: 'Yes' },
     { id: 'false', name: 'No' },
];

export const SELLING_GROUP_TRAINING_LEVEL_OPTIONS = [
     { id: 'foundational', name: 'Foundational' },
     { id: 'advanced_cams-certified', name: 'Advanced - CAMS Certified' },
     { id: 'advanced_cams-4teens', name: 'Advanced - CAMS-4Teens' },
     { id: 'advanced_other', name: 'Advanced - Other' },
];

export const SELLING_GROUP_TRAINING_METHOD_OPTIONS = [
     { value: 'package', label: 'Package' },
     { value: 'book', label: 'Book' },
     { value: 'ce-credits', label: 'CE Credits' },
     { value: 'digital', label: 'Digital' },
     { value: 'in-person', label: 'In-Person' },
     { value: 'live-training', label: 'Live Training' },
     { value: 'live', label: 'Live' },
     { value: 'on-demand', label: 'On-demand' },
     { value: 'online-course', label: 'Online Course' },
     { value: 'online', label: 'Online' },
     { value: 'teams', label: 'Teams' },
];

export const SHIPMENT_STATUSES = [
     { id: 'DRAFT', name: 'Draft' },
     { id: 'NOT_SHIPPED', name: 'Not Shipped' },
     { id: 'SHIPPED', name: 'Shipped' },
];

export const SHIPPING_STATUSES = [
     { id: 'NOT_SHIPPED', name: 'Not Shipped' },
     { id: 'SHIPPED', name: 'Shipped' },
];

export const TRACKING_CARRIERS = [
     { id: 'UNKNOWN', name: 'Unknown' },
     { id: 'FEDEX', name: 'FedEx' },
     { id: 'USPS', name: 'USPS' },
     { id: 'UPS', name: 'UPS' },
     { id: 'DHL', name: 'DHL' },
];

export const TRACKING_CARRIERS_VALUES = {
     UNKNOWN: 'UNKNOWN',
     FEDEX: 'FEDEX',
     USPS: 'USPS',
     UPS: 'UPS',
     DHL: 'DHL',
};

export const PAYMENT_STATUSES = [
     { id: 'Completed', name: 'Completed' },
     { id: 'AwaitingPayment', name: 'Awaiting Payment' },
     { id: 'Paid - Unknown', name: 'Paid - Unknown' },
     { id: 'Canceled', name: 'Canceled' },
];

export const PAYMENT_STATUS_LABEL = {
     Completed: 'Completed',
     AwaitingPayment: 'Awaiting Payment',
     'Paid - Unknown': 'Paid - Unknown',
     Canceled: 'Canceled',
     Open: 'Open',
     Close: 'Close',
};

export const TYPE_CHARTS = [
     { id: 'PieChart', name: 'Pie Chart' },
     { id: 'BarChart', name: 'Bar Chart' },
     { id: 'ColumnChart', name: 'Column Chart' },
     { id: 'Table', name: 'Table Chart' },
];
